import { each } from 'lodash'
import { app, menu, search, modal } from '../utils/store'
import { activate, deactivate } from '../utils/states'
import { media } from '../utils/media'

export default class Search {
    constructor() {
        this.url = new URL(window.location.href)

        this.main = {
            toggler: document.getElementById('menu-toggler'),
            logo: document.getElementById('logo'),
        }

        this.menu = {
            toggler: document.getElementById('menu-toggler'),
            main: document.getElementById('main-menu')
        };

        this.search = {
            input: document.getElementById('global-search'),
            toggler: document.getElementById('search-toggler'),
        }

        this.language = {
            select: document.querySelector('#select-language select[name="language"]'),
            options: document.querySelectorAll('#select-language select[name="language"] option')
        }

        this.body = document.body;

        this.toggle();

        if (app.page == 'search') {
            this.onLanguageChange()
        }
    }

    toggle = () => {
        this.search.toggler.addEventListener('click', (event) => {
            event.preventDefault()

            search.isActive = true

            activate(this.main.toggler)
            activate(this.search.toggler)
            activate(this.search.input)
            // deactivate(app.header)
            deactivate(document.getElementById('login-reserved'))
            deactivate(document.querySelector('[data-menu-products]'))
            deactivate(document.querySelector('[data-menu-actions]'))
            deactivate(document.querySelector('[data-menu-store]'))
            deactivate(document.querySelector('[data-menu-contract]'))
            document.body.classList.add('overflow-hidden')
            document.body.classList.add('search-active')

            this.search.input.querySelector('input.search-global').focus()
        });

        this.menu.toggler.addEventListener('click', (event) => {
            if (search.isActive) {
                if (!menu.isOpen) {
                    deactivate(this.main.toggler)
                }

                deactivate(this.search.toggler)
                deactivate(this.search.input)
                // activate(app.header)
                activate(document.getElementById('login-reserved'))
                activate(document.querySelector('[data-menu-products]'))
                activate(document.querySelector('[data-menu-actions]'))
                activate(document.querySelector('[data-menu-store]'))
                activate(document.querySelector('[data-menu-contract]'))

                document.body.classList.remove('overflow-hidden')
                document.body.classList.remove('search-active')

                // menu.isOpen = false
                search.isActive = false
            }
        });
    }

    onLanguageChange = () => {
        let searchParameters = this.url.search.split('&')
        searchParameters.shift()

        each(this.language.options, (option) => {
            option.value = option.value + '&' + searchParameters.join()
        })
    }
}